export default "__VITE_ASSET__BMvDQ68W__"